
import { MEDICATION_INTERACTIONS_SUCCESS } from './actions.js'

const defaultState = {
  /* loading: true,
   * error: false, */
  drugs: [],
  interactions: []
}

export default function reducer (state = defaultState, action) {
  switch (action.type) {
    case MEDICATION_INTERACTIONS_SUCCESS:
      return {
        ...state,
        interactions: action.interactions
      }
    default:
      return state
  }
}
